import React from 'react';
import { Provider } from '@mashvisor/design-system';
import PropTypes from 'prop-types';
import ProductSEO from './product-seo';
import PluginsLoader from '../../components/plugins-loader';
import useExitIntent from '../ExitIntentPopup/useExitIntent';
import './../layout.css';

const ProductLayout = ({
  children,
  metaTitle,
  metaDescription,
  metaKeywords,
  canonicalLink,
}) => {
  useExitIntent({
    isExitIntentEnabled: true,
  });
  return (
    <Provider>
      <ProductSEO
        metaDescription={metaDescription}
        metaTitle={metaTitle}
        metaKeywords={metaKeywords}
        canonicalLink={canonicalLink}
      />
      <PluginsLoader></PluginsLoader>
      {children}
    </Provider>
  );
};

ProductLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ProductLayout;
